module.exports = __webpack_public_path__ + "media/images/siusk24-alsendo-2de03a8a.svg";